import React from 'react';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { getAvailabilityDisplay } from '../../util/mapAvailability';

const sizeColumn = {
  header: <TranslatedCopy id='global.size' />,
  id: 'sizeCode'
};

const getDateColumns = (dates, locale) =>
  dates.map(date => {
    // since date doesn't include time, make the date the same regardless of locale
    const dateObj = new Date(date);
    const userTimezoneOffset = dateObj.getTimezoneOffset() * 60000;
    const adjustedDateObj = new Date(dateObj.getTime() + userTimezoneOffset);
    return {
      header: (
        <span>{adjustedDateObj.toLocaleDateString(locale, { month: 'long', day: 'numeric', year: 'numeric' })}:</span>
      ),
      id: `availability.${date}`,
      cell: size => {
        const { GENERAL, CONTRACT } = size.availability[date] || { GENERAL: 0, CONTRACT: 0 };
        const allAvailability = getAvailabilityDisplay(GENERAL + CONTRACT);

        return <span className='text-color-secondary'>{allAvailability}</span> || null;
      }
    };
  });

const getFutureAvailabilitiesColumns = (dates, locale) => [sizeColumn, ...getDateColumns(dates, locale)];

export default getFutureAvailabilitiesColumns;
